import { Component, OnInit } from '@angular/core';

import { Analytics } from '../../shared/analytics';
import { AdminListEnum } from '../../shared/services/admin-lists/enum/admin-list.enum';
import { CurrencyValueModel } from '../shared/models/currency-value';
import { PldCommonService } from '../shared/pld-common.service';
import { PldFormService } from '../shared/pld-form.service';
import { PldNavigationService } from '../shared/pld-navigation.service';

@Component({
  selector: 'pld-money',
  templateUrl: './money.component.html',
  styleUrls: ['../shared/pld-styles.scss']
})
export class MoneyComponent implements OnInit {
  pageId = 'pld-money';
  expectedBalances: any[] = [];
  isBtnDisabled = false;
  hintObject: any;

  constructor(
    private analyticsLib: Analytics,
    private pldFormService: PldFormService,
    private pldCommonService: PldCommonService,
    public navigationService: PldNavigationService
  ) {
    this.hintObject = {};
  }

  ngOnInit() {
    this.expectedBalances = this.pldCommonService.getAdminList(AdminListEnum.AVG_BALANCE);
    this.resolveHint();
    this.refreshButton();

    // tslint:disable-next-line: early-exit
    if (this.pldFormService.getProperty('avg_balance')) {
      this.expectedBalances.forEach(element => {
        const amount = this.pldFormService.getProperty('avg_balance').amount;

        element.checked = !!(amount === element.code);
      });
    }
  }

  resolveHint() {
    this.hintObject.message = `Es la cantidad de dinero que esperas mantener depositada en tus cuentas mensualmente.`;
    this.hintObject.value = `offer`;
  }

  refreshButton() {
    this.isBtnDisabled =
      !this.pldFormService.getProperty('avg_balance') || !this.pldFormService.getProperty('avg_balance').amount;
  }

  changeAmount(event: any) {
    const balance = new CurrencyValueModel();
    balance.amount = event.value;
    this.pldFormService.setProperty('avg_balance', balance);
    this.refreshButton();
  }
}
